module.exports = __webpack_public_path__ + "img/kefu_left.0082ca3a.png";